var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 1.25C12.7109 1.25 16.1797 4.71875 16.1797 9C16.1797 13.2812 12.7109 16.75 8.42969 16.75C4.14844 16.75 0.679688 13.2812 0.679688 9C0.679688 4.71875 4.14844 1.25 8.42969 1.25ZM15.1797 9C15.1797 5.28125 12.1172 2.25 8.42969 2.25C4.67969 2.25 1.67969 5.3125 1.67969 9C1.67969 12.75 4.71094 15.75 8.42969 15.75C12.1484 15.75 15.1797 12.7188 15.1797 9ZM10.5234 11.7812L7.96094 9.9375C7.86719 9.84375 7.83594 9.75 7.83594 9.625V4.625C7.83594 4.4375 7.99219 4.25 8.21094 4.25H8.64844C8.83594 4.25 9.02344 4.4375 9.02344 4.625V9.21875L11.2109 10.8125C11.3672 10.9375 11.4297 11.1562 11.3047 11.3438L11.0234 11.6875C10.9297 11.8438 10.6797 11.9062 10.5234 11.7812Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9c035925.svg";
export { ForwardRef as ReactComponent };